export default {
  'transactionHistory.paymentRecordTip':
    'The Payment Records are for the past 6 months.',
  'transactionHistory.change': 'Charge({currencySymbol})',
  'transactionHistory.paymentMethod': 'Payment Method',
  'transactionHistory.channel': 'Channel',
  'transactionHistory.status': 'Status',
  'transactionHistory.date': 'Date',
  'transactionHistory.receipt': 'Receipt',
};
